import React from "react";
import { useSelector } from "react-redux";
import "../styles/spa.css";
import Logo from "../assets/images/logo-with-text.png";
import withMiddleware from "../middleware";
import { useHistory } from "react-router-dom";
import { routeAfterLoginOrSignup, getRoutes } from "./auth/login/handler";

function PostRegistrationInstructions(props) {
  const history = useHistory();
  const { user } = useSelector((state) => ({
    user: state.app.user,
  }));

  const routeAfterDecision = () => {
    // TODO: Route user to the instructions page.
    const route = getRoutes(user?.user_type);
    routeAfterLoginOrSignup(history, route, user);
  };
  return (
    <div id="invitation-container">
      <img src={Logo} className="app-logo" alt="OptimalHRV Logo" />
      <div className="top-right-ele" onClick={routeAfterDecision}>
        <span>
          <b>Open Dashboard</b>
        </span>
      </div>
      <div className="welcome-content">
        <h1 className="title" style={{ marginBottom: 0 }}>
          Thank you for joining Optimal HRV ♥️
        </h1>
        <div>
          <p style={{ textAlign: "center", marginBottom: "2rem" }}>
            Please access the{" "}
            <a href="https://docs.optimalhrv.com/" target="_blank">
              instructions
            </a>{" "}
            to start your HRV Tracking and HRV Biofeedback journey. The Optimal HRV platform is robust and the instructions will allow you to get the
            most out of your membership.
          </p>

          <h3>📱 Download Our Official Mobile App</h3>
          <p>
            To take HRV readings, you’ll need the Optimal HRV app and a <strong>compatible heart rate monitor</strong>, want to explore readers we
            offer?{" "}
            <a href="https://www.optimalhrv.com/hrvmonitoringdevice" target="_blank">
              click here
            </a>
          </p>
          <ul>
            <li>
              <a href="https://apps.apple.com/us/app/optimal-hrv/id1501292206" target="_blank">
                iOS App: Download on the App Store
              </a>
            </li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.optimalhrv.app&hl=en_US&gl=US" target="_blank">
                Android App: Get it on Google Play
              </a>
            </li>
          </ul>

          <h3>🌐 Helpful Links</h3>
          <p>To help you on the HRV journey, here are some resources and instructional videos.</p>
          <ul>
            <li>
              <a href="https://docs.optimalhrv.com/" target="_blank">
                Getting started instructions
              </a>
            </li>
            <li>
              <a href="https://www.optimalhrv.com/podcast" target="_blank">
                OptimalHRV podcasts
              </a>
            </li>
            <li>
              <a href="https://www.optimalhrv.com/latest" target="_blank">
                OptimalHRV blog posts
              </a>
            </li>
            <li>
              <a href="https://optimalhrv.com/" target="_blank">
                Official website
              </a>
            </li>
            <li>
              <a href="https://www.optimalhrv.com/hrvmonitoringdevice" target="_blank">
                Heart rate monitoring devices
              </a>
            </li>
          </ul>

          <h3>💬 Need Help?</h3>
          <p>If you have any questions or run into issues, we’re here to support you.</p>
          <p>
            📧 Reach out anytime at <a href="mailto:support@optimalhrv.com">support@optimalhrv.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default withMiddleware(PostRegistrationInstructions);
